import { Components, Theme } from '@mui/material';

import palette from '../baseTheme/palette';

export const MuiInputBase: Components<Theme>['MuiInputBase'] = {
  styleOverrides: {
    root: {
      background: palette.background.surface,
      border: `1px solid ${palette.border}`,
    },
    multiline: {
      height: 'auto',
      minHeight: '40px',
    },
  },
};
